var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFamily(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 116,
    viewBox: "0 0 140 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.027 25.174c5.792 4.855 10.57 8.396 14.334 10.624 5.646 3.34-3.996 23.919-14.334 23.919-10.339 0-17.104-16.87-14.855-23.92 5.278-1.373 10.23-4.914 14.855-10.623z",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.698 49.79c2.131-4.558 3.197-7.746 3.197-9.564 0-2.727-4.736-16.293 3.845-21.917 8.582-5.624 9.016-5.31 13.718-3.665 4.702 1.646 7.843-7.13 17.574 4.96 9.73 12.09 3.715 14.914 3.715 17.768 0 2.854 5.913 13.911 0 18.128 3.572 2.811 5.359 6.04 5.359 9.687M17.304 37.028c-3.539-12.494-.472-19.606 9.199-21.337 7.457-6.558 14.209-5.067 23.219 0 1.255 1.22 3.443 1.83 6.564 1.83-.614 6.405-2.802 9.607-6.564 9.607-5.644 0-18.426-7.724-25.422 0-5.343 15.318-1.853 30.795 11.784 32.589 8.067 0 13.24-6.859 15.52-20.577V27.128M56.942 28.193c.503 3.427.12 7.074-1.15 10.94",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.05 55.5c.634 5.536-3.089 9.203-11.168 11.001C7.803 68.3 3.841 75.646 3.994 88.541v24.309M18.353 90.707v22.143M122.032 90.707v22.143M112.34 58.302c1.936 4.503 5.82 7.431 11.656 8.784 8.752 2.03 11.877 8.328 11.877 23.62v22.144",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.214 58.302c-1.339 4.59-3.92 6.885-7.744 6.885 1.392 4.722 4.46 11 13.916 11 6.304 0 10.6-3.667 12.89-11M45.985 55.5c.022 2.879 1.659 5.556 4.91 8.032",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.206 63.532c2.661 4.239 6.287 6.359 10.878 6.359 4.592 0 8.71-2.845 12.355-8.535M85.637 63.532C74.577 62.488 66.864 59.81 62.5 55.5c-4.487 1.342-6.558 6.138-6.214 14.39.798 9.008 4.803 14.73 12.017 17.165 7.519-.986 12.213-7.59 14.083-19.81M98.228 36.812h4.587c1.016-.004 1.525 1.559 1.525 4.688 0 5.964 1.277 4.694 3.062 4.694M109.122 36.734H115M102.815 50.826c2.06 1.56 4.162 1.56 6.307 0M31 50.826c3.078 3.087 6.345 3.087 9.8 0",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.848 79.226c1.442 1.359 3.16 1.359 5.152 0M69.424 67.245v5.576c-.407.575-1.266.863-2.576.863M62.5 85.576c-.547 3.035-2.619 5.217-6.214 6.545C50.894 94.114 42 95.938 43.5 112.47M75.332 85.576c.548 3.035 2.619 5.217 6.214 6.545 5.392 1.993 14.286 3.817 12.786 20.348",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 90.707c3.04 4.34 5.848 6.511 8.424 6.511 2.576 0 5.66-2.17 9.251-6.511M83.769 108.008v4.961M55.769 108.008v4.961M62.5 85.576c-.547 3.035-2.619 5.217-6.214 6.545C50.894 94.114 42 95.938 43.5 112.47M55.658 68.66c-.494-.461-6.748-13.38 0-18.739 2.54-7.966 21.103-5.855 25.722-1.802 5.585 1.802 8.185 13.032 1.298 23.158M27.119 33.176h6.051M45.985 33.176H40.8c-2.652-.089-3.978 1.353-3.978 4.324v6.639c-1.014.561-2.232.711-3.653.45",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 98.5,
    cy: 41.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 112.5,
    cy: 41.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 29.5,
    cy: 37.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 43.5,
    cy: 37.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 62.5,
    cy: 68.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D15",
    cx: 75.5,
    cy: 68.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    opacity: 0.3,
    d: "m59.707 90.707-13.722 6.511-2.485 15.25 51 .382-2.03-13.828-13.795-8.315-8.744 6.511z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamily);
export default __webpack_public_path__ + "static/media/icon-family.b98f3017a1640ae35fb637f4b4fe63e7.svg";
export { ForwardRef as ReactComponent };